import {ConsultaColunaBanco} from "./consulta-coluna-banco";

export class ConteudoColunaRim {
    id: number;
    posicao: number;
    descricao: string;
    alinhamento: string;
    largura: number;

    consultaColunaBanco: ConsultaColunaBanco;
}